<script>
    import { toNumber, isNull, indexOf, debounce } from 'lodash'
    import InlineComponents from '../inline-components/InlineComponents.mixin.vue'
    import { breakpoint } from '../../utility'
    import AnswerDebug from './AnswerDebug.vue'
 
    export default {
        name: "Answer",
        components: {AnswerDebug},
        filters: {
            imageSize: function(value) {
                return value
            }
        },
        mixins: [InlineComponents],
        props: {
            'answer': {
                type: Object,
                required: true
            },
            'isSelectedAnswer': {
                type: Boolean,
                required: true
            },
            'initValue': {
                type: String,
                default: '',
                required: false
            },
            'answerIndex': {
                type: Number,
                required: true
            },
            'answerText': {
                type: String,
                default: null
            },
            'forceHighlighted': {
                type: Boolean,
                default: null
            },
            'effectedWarningEnabled': {
                type: Boolean,
                default: false
            },
            'required': {
                type: Boolean,
                default: false
            }
        },
        data: function() { return {
            value: this.initValue,
            recalculateOnChange: true,
            dontCalculateNextValueChange: false,
            imageSrc: null
        }},
        computed: {
            isSelected () {
                if(!this.isSelectedAnswer) {
                    return false
                }

                return true
            },
            aboveZero() {
                return toNumber(this.value) > 0
            },
            isValid() {
                return true
            },
            isSingleAnswer() {
                return this.$parent.question.answers.length === 1
            },
            isColorized() {
                if(isNull(this.forceHighlighted)) {
                    if(this.isSingleAnswer) {
                        if(this.aboveZero && this.isValid) {
                            return true
                        }
                    } else {
                        return this.isSelectedAnswer && this.isValid
                    }

                    return false
                }

                return this.forceHighlighted                
            },
            hasImage() {
                return !isNull(this.answer.media)
            },
            styleObj() {
                return {
                    backgroundColor: this.answer.color
                }
            },
            overrideByContactForm() {
                return this.$parent.question.override_answers_by_contact_btn
            }
        },
        watch: {
            value: function(value) {
                if(this.dontCalculateNextValueChange) {
                    this.dontCalculateNextValueChange = false
                } else {
                    this.selectAnswer(null, this.answer.id)
                    this.$emit('valueChanged', value)
                }
            },
            isColorized: {
                handler: function(value) {
                    if(value) {
                        this.$store.colorizedQuestions.push(this.answer.question_id)
                    }

                    if(!value) {
                        let index = indexOf(this.$store.colorizedQuestions, this.answer.question_id)
                        if(index >= 0) {
                            this.$store.colorizedQuestions.splice(index, 1)
                        }  
                    }
                },
                immediate: true
            }
        },
        created() {
            this.setImageSrc()
        },
        mounted() {
            if(this.hasImage) {
                window.addEventListener('resize', debounce(this.setImageSrc, 150))
            }
        },
        methods: {
            selectAnswer(event, answerId = this.answer.id) {
                if(this.$store.readOnly) {
                    return
                }

                if(!isNull(event) && this.effectedWarningEnabled) {
                    this.goingToChangeValue()
                    event.preventDefault(event)
                    return
                }

                if(!this.isSelectedAnswer) {
                    this.$emit('selectAnswer', {
                        answerId: answerId,
                        answerIndex: this.answerIndex
                    })
                }
            },
            showImage(e) {
                let breakpointValue = breakpoint.getValue()

                if(breakpointValue === 'large' || breakpointValue === 'medium') {
                    e.stopPropagation()
                    this.$event.$emit('show-image', assetsUrl+"/"+this.answer.media.public_path)
                }
            },
            setValueSilently(value) {
                this.dontCalculateNextValueChange = true
                this.value = value
            },
            setImageSrc() {
                if(this.hasImage) {
                    let breakpointValue = breakpoint.getValue()

                    if(breakpointValue === 'large') {
                        this.imageSrc = assetsUrl+"/"+this.answer.media.small_path
                    } else {
                        this.imageSrc = assetsUrl+"/"+this.answer.media.medium_path
                    }                    
                } else {
                    this.imageSrc = null
                }

                return this.imageSrc
            },
            goingToChangeValue() {
                if(this.effectedWarningEnabled) {
                    $(':focus').blur()
                    this.$event.$emit('call-change-warning-modal')
                }
            },
            callContactModal() {
                this.$event.$emit('call-contact-modal', {scope: 'contact'})
            }
        },
    }
</script>